"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardTypes = exports.CreditCardNetwork = void 0;
exports.detectCreditCardType = detectCreditCardType;
var CreditCardNetwork;
(function (CreditCardNetwork) {
    CreditCardNetwork[CreditCardNetwork["Amex"] = 0] = "Amex";
    CreditCardNetwork[CreditCardNetwork["Mastercard"] = 1] = "Mastercard";
    CreditCardNetwork[CreditCardNetwork["Visa"] = 2] = "Visa";
})(CreditCardNetwork || (exports.CreditCardNetwork = CreditCardNetwork = {}));
exports.CreditCardTypes = [
    {
        name: "American Express",
        network: CreditCardNetwork.Amex,
        regexp: /^3[47][0-9]{13}$/,
        mangopayCardType: "AMEX",
        cvvLength: 4,
        maxNumberLength: 15,
        isValid: true,
    },
    {
        name: "Mastercard",
        network: CreditCardNetwork.Mastercard,
        regexp: /^(5[1-5][0-9]{14}|2221[0-9]{12}|222[2-9][0-9]{12}|22[3-9][0-9]{13}|2[3-6][0-9]{14}|27[01][0-9]{13}|2720[0-9]{12})$/,
        mangopayCardType: "CB_VISA_MASTERCARD",
        maxNumberLength: 16,
        isValid: true,
    },
    {
        name: "Visa",
        network: CreditCardNetwork.Visa,
        // Second part of regexp should match mangopay testing VISA/MC cards
        regexp: /^(4[0-9]{12}(?:[0-9]{3})?|35699900000001(32|57))$/,
        mangopayCardType: "CB_VISA_MASTERCARD",
        maxNumberLength: 16, // can be 13 or 16
        isValid: true,
    },
];
// TODO doesn't belong here
function detectCreditCardType(ccNumber) {
    let detectedCCType = { isValid: false };
    exports.CreditCardTypes.forEach((ccType) => {
        if (ccType.regexp && ccNumber.match(ccType.regexp) != null) {
            detectedCCType = ccType;
        }
    });
    return detectedCCType;
}
//# sourceMappingURL=CreditCardType.js.map